import React, { useEffect, useState } from "react";
import Hero from "../../common/Hero";
import Footer from "../../common/Footer";
import BlogImage from "../../assests/images/blog.jpg";
import Slider from "react-slick";
import Navbar from "../../common/Navbar";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE;

const Gallery = () => {
  const [mediaItems, setMediaItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // Main slider
  const mainSliderSettings = {
    dots: false,
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 1800,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
  };

  const secondarySliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 1500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  // ✅ Fetch Gallery Images From Backend
  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/service/readAllService`
        );

        setMediaItems(res?.data?.data?.services || []);
      } catch (error) {
        console.error("Gallery fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, []);

  return (
    <>
      <Navbar />
      <Hero text="Gallery" text1="Our Work" image={BlogImage} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* SEO Title */}
        <h1 className="text-3xl md:text-5xl text-gray-800 font-bold text-center my-8">
          MF Carpet and Blinds Installation Gallery UK
        </h1>

        {/* SEO Description */}
        <p className="text-center text-gray-600 mb-12 max-w-3xl mx-auto">
          Explore our premium made-to-measure blinds and carpet installation projects across the UK.
          We provide professional fitting services, luxury window blinds, blackout blinds, and
          modern home interior solutions designed to enhance privacy and style.
        </p>

        {/* Main Slider */}
        {loading ? (
          <p className="text-center py-16">Loading gallery...</p>
        ) : (
          <>
            <div className="mb-12">
              {/* <Slider {...mainSliderSettings}>
                {mediaItems.map((item, index) => (
                  <div key={index} className="cursor-pointer">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-[400px] object-cover rounded-2xl shadow-lg hover:scale-105 transition-transform"
                      loading="lazy"
                    />
                  </div>
                ))}
              </Slider> */}
            </div>

            {/* Secondary Slider */}
            <div>
              <h2 className="text-2xl md:text-4xl font-semibold text-center mb-8 text-gray-800">
                More of Our Work
              </h2>

              <Slider {...secondarySliderSettings}>
                {mediaItems.map((item, index) => (
                  <div key={index} className="px-2">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-64 object-cover rounded-xl shadow-md hover:scale-105 transition-transform"
                      loading="lazy"
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </>
        )}

        {/* SEO Content Section */}
        <div className="mt-20 max-w-4xl mx-auto text-gray-600 space-y-6">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1A8F5A]">
            Professional Blinds & Carpet Installation Services UK
          </h2>

          <p>
            Our gallery showcases high-quality blinds installation projects
            completed for homes and businesses across the United Kingdom.
            We specialize in roller blinds, vertical blinds, venetian blinds,
            and luxury carpet fitting services with precision craftsmanship.
          </p>

          <p>
            All our products are custom made to measure, ensuring perfect
            fitting, modern design, and long-lasting durability. Contact us
            today for a free consultation and professional installation quote.
          </p>
        </div>
      </div>
      <div className="mt-12 p-20">
       <Slider {...secondarySliderSettings}>
                {mediaItems.map((item, index) => (
                  <div key={index} className="px-2">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-64 object-cover rounded-xl shadow-md hover:scale-105 transition-transform"
                      loading="lazy"
                    />
                  </div>
                ))}
              </Slider>
</div>
      <Footer />
    </>
  );
};

export default Gallery;